import React, { useEffect, useState } from 'react';
import './style.css';
import { toastr } from "react-redux-toastr";
import CalendarIcon from "../../icons/calendar-icon.png";
import SadIconAsia from "../../icons/sad-icon.png";
import SadIconGras from "../../icons/sad-icon-green.png";
import { useSelector } from "react-redux";
import { getLanguage } from "../../components/LanguageModal/reducer";
import translations from "../../components/LanguageModal/translations";
import {getReqExp, getFetchingReq, getHasMoreReq, getStatusFilter, getStateFilter} from "./reducer";
import {fetchMeetings, updateMeetingStatus, CARDS_PER_PAGE, setCloseFilter} from "./actions";
import { ReactComponent as VectorAsia } from '../../icons/vector-red.svg';
import { ReactComponent as VectorGras } from '../../icons/vector-green.svg';
import { ReactComponent as VectorIconAsia } from "../../icons/vector-expo-red.svg";
import { ReactComponent as VectorIconGras } from '../../icons/vector-expo-green.svg';
import { setWindowScrollPosition } from "../../components/WindowDimensions";
import InfiniteView from "../../components/InfiniteView";
import MeetingComponent from "../../components/MeetingComponent/MeetingComponent";
import {Dropdown, Modal} from "semantic-ui-react";
import { getTypeExhibition } from "../Home/reducer";
import FormMeeting from "../../components/FormMeeting";
import { subscribeToPushNotifications } from "../../components/UserLogin/actions";
import UnloginPopup from "../../components/UnloginPopup";

export default function AsiaMeet(props) {
    const { token, navigate, dispatch, routeAction, isPageReloaded, mixpanel } = props;
    const statusFilter = useSelector((state) => getStatusFilter(state.meets));
    const isMeetsFilterOpen = useSelector((state) => getStateFilter(state.meets))

    const [openLogin, setOpenLogin] = useState(false);
    useEffect(() => {
        dispatch(setCloseFilter())
        if(!token) {
            navigate('/', {state: {meetUnLogin: true}})
        }
    }, []);


    const language = useSelector(getLanguage);
    const languageString = language[0] + language[1];
    const t = (key) => {
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };



    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));
    const dataExhibition = {
        asia: {
            vector: (props) => <VectorAsia {...props} />,
            vectorIcon: (props) => <VectorIconAsia {...props} />,
            sadIcon: SadIconAsia,
            color: '#D81524'
        },
        gras: {
            vector: (props) => <VectorGras {...props} />,
            vectorIcon: (props) => <VectorIconGras {...props} />,
            sadIcon: SadIconGras,
            color: '#037C00',
        }
    };

    const isIOS = () => {
        return /iPad|iPhone|iPod/.test(navigator.userAgent);
    };


    const requestNotificationPermission = () => {
        try {
            switch (Notification.permission) {
                case "default":
                    return {
                        text: '👌 ' + t('pushDefault'),
                        onClick: () => dispatch(subscribeToPushNotifications(token)),
                        style: {
                            cursor: 'pointer',
                            borderRadius: 8,
                            background: dataExhibition[typeExhibition].color,
                            fontWeight: 'bold',
                            color: 'white',
                            padding: '0 5px',
                            margin: '5px 0'
                        },
                    }
                case "granted":
                    return {
                        text: '❤️ ' + t('pushAllow'),
                        style: {cursor: 'default'}
                    }
                case "denied":
                    return {
                        text: '😢 ' + t('pushDenied'),
                        style: {cursor: 'pointer'},
                        onClick: () => navigate('/instruction')
                    }
            }
        }
        catch (error) {
            console.log(error);
        }
    };



    const meets = useSelector((state) => getReqExp(state.meets));
    const isFetching = useSelector((state) => getFetchingReq(state.meets));
    const hasMore = useSelector((state) => getHasMoreReq(state.meets));

    const [selectedType, setSelectedType] = useState('planned');

    const getStatusesByType = (type) => {
        switch (type) {
            case 'planned':
                return ['accepted'];
            case 'canceled':
                return ['canceled', 'rejected', 'deleted'];
            case 'finished':
                return ['completed'];
            case 'requests':
                return ['directed'];
            default:
                return [];
        }
    };

    // Общая функция загрузки встреч
    const readMeetings = (page) => {
        const params = {
            page,
            per_page: CARDS_PER_PAGE,
            order: 'asc',
            orderby: ['on_date', 'on_time'],
            event: typeExhibition.toUpperCase() === 'GRAS' ? 'GRAS 2025' : 'ASIAEXPO 2025',
            lang: languageString,
        };

        if (selectedType && selectedType.length > 0) {
            params['statuses'] = getStatusesByType(selectedType)
        }

        dispatch(fetchMeetings(params, token, languageString));
    };

    const loadMore = () => {
        readMeetings(Math.round(meets.length / CARDS_PER_PAGE) + 1);
    }

    useEffect(() => {
        readMeetings(1);
    }, [selectedType]);

    const Vector = (props) => dataExhibition[typeExhibition].vector(props);
    const VectorIcon = (props) => dataExhibition[typeExhibition].vectorIcon(props);

    const MeetingCard = ({ meet }) => (
        <MeetingComponent
            cardActions={meet?.actions ? meet?.actions : []}
            token={token}
            icon={CalendarIcon}
            cardId={meet.id}
            cardDate={meet.on_date}
            cardTime={meet.on_time}
            updateFunc={readMeetings}
            cardStatus={{
                ru: meet.meeting_status_name,
                en: meet.meeting_status_name_en
            }}
            content={
                <div>
                    <div className='asiameet-card-text'>{meet.name}</div>
                    <div className="asiameet-card-text">
                        <span style={{ fontWeight: 'bold' }}>{t('company')}: </span>
                        {languageString === "ru"
                            ? meet.respondent_exponent_name
                            : meet.respondent_exponent_name_en}
                    </div>
                    <div className="asiameet-card-text">
                        <span style={{ fontWeight: 'bold' }}>{t('job_title')}: </span>
                        {languageString === "ru"
                            ? meet.respondent_job_title
                            : meet.respondent_job_title_en}
                    </div>
                    <div className="asiameet-card-text">
                        <span style={{ fontWeight: 'bold' }}>{t('responder')}: </span>
                        {languageString === "ru"
                            ? meet.respondent_user_name
                            : meet.respondent_user_name_en}
                    </div>
                    <div className="asiameet-card-text">
                        <span style={{ fontWeight: 'bold' }}>{t("placeholderPlaceText")}:</span> {meet.placement}
                    </div>
                    <div className="asiameet-card-text">
                        <span style={{ fontWeight: 'bold' }}>{t('initiator')}: </span>
                        {languageString === "ru"
                            ? meet.initiator_user_name
                            : meet.initiator_user_name_en}
                    </div>
                    <div className="asiameet-card-text">
                        <span style={{ fontWeight: 'bold' }}>{t('event')}: </span>
                        {meet.expo_event}
                    </div>
                </div>
            }
        />
    );

    const [openCreateMeet, setOpenCreateMeet] = useState(false);

    // console.log(selectedType)

    return (
        <div className="asiameet-view">
            <div className="asiameet-dropdown-container">
                <Dropdown
                    className={`filter-input ${typeExhibition}`}
                    placeholder={t('meetStatus')}
                    selection
                    options={[
                        { key: 'planned', text: t('planned'), value: 'planned' },
                        { key: 'canceled', text: t('canceledMeets'), value: 'canceled' },
                        { key: 'finished', text: t('finished'), value: 'finished' },
                        { key: 'requests', text: t('requests'), value: 'requests' },
                    ]}
                    value={selectedType}
                    onChange={(e, { value }) => setSelectedType(value)}
                />
            </div>

            <div className="asiameet-faq-container">
                <div className="asiameet-faq" onClick={() => setOpenCreateMeet(true)}>
                    {t("faqAsiameet")}
                    <Vector className="asiameet-vector" alt="Vector_expo_card" />
                </div>
                <Modal
                    centered
                    open={openCreateMeet}
                    onClose={() => setOpenCreateMeet(false)}
                    className='exponent-card-popup'
                >
                    <Modal.Content>
                        <FormMeeting
                            handleClose={() => setOpenCreateMeet(false)}
                            token={token}
                        />
                    </Modal.Content>
                </Modal>
            </div>

            {!isIOS() && <div className='push-text' style={requestNotificationPermission().style}
                  onClick={requestNotificationPermission().onClick}>
                {requestNotificationPermission().text}
            </div>}
            <UnloginPopup open={openLogin} setOpen={setOpenLogin} text={t('onlyReg')} />
            <InfiniteView
                dataLength={meets.length}
                nextFetch={loadMore}
                hasMore={hasMore}
                className="asiameet-infinite"
                isLoading={isFetching}
                dataList={navigator.onLine ? (
                    <div className="asiameet-content">
                        {meets.map((meet) => (
                            <MeetingCard key={meet.id} meet={meet} />
                        ))}
                    </div>
                ) : (
                    <div className='view-bookmarks'>
                        <img src={dataExhibition[typeExhibition].sadIcon} width={50} height={50} alt="" />
                        <span className='text-bookmark'>{t('notFound')}</span>
                    </div>
                )}
                hideEndMessage={true}
                mustAuth={false}
                loaderText={languageString === 'ru' ? 'Загрузка...' : 'Loading...'}
                zeroText={(
                    <div className='view-bookmarks'>
                        <img src={dataExhibition[typeExhibition].sadIcon} width={50} height={50} alt="" />
                        <span className='text-bookmark'>
                            {languageString === 'ru'
                                ? `Встречи со статусом "${t(selectedType.toLowerCase()).toLowerCase()}" не найдены`
                                : `Meetings with status "${t(selectedType.toLowerCase().toLowerCase())}" not found`}
                        </span>
                    </div>
                )}
            />
        </div>
    );
}